import {buildRumBeaconSnippet} from "@buildwithflux/telemetry-schema/rumBeaconSnippet";
import {RUM_SEARCH_SITE_TOKEN, RUM_SITE_TOKEN_QUERY_PARAM} from "@buildwithflux/telemetry-schema/rumSiteTokens";
import CssBaseline from "@mui/material/CssBaseline";
import {ThemeProvider} from "@mui/material/styles";
import {Links, Meta, Outlet, Scripts, ScrollRestoration} from "react-router";

import Layout from "./components/Layout";
import {GlobalStructuredData} from "./seo";
import "./styles/fonts.css";
import {theme} from "./styles/theme";

export function HtmlLayout({children}: {children: React.ReactNode}) {
    return (
        <html lang="en" suppressHydrationWarning>
            <head suppressHydrationWarning>
                <meta charSet="utf-8" />
                <link rel="icon" href="/favicon.ico" />
                <link rel="apple-touch-icon" href="/logo192.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="theme-color" content="#000000" />
                <link rel="manifest" href="/manifest.json" />
                <link rel="preconnect" href="https://firestore.googleapis.com" />
                <link rel="preconnect" href="https://firebaseinstallations.googleapis.com" />
                <link rel="preconnect" href="https://firebase.googleapis.com" />
                <Meta />
                <GlobalStructuredData />
                <Links />
                <style
                    dangerouslySetInnerHTML={{
                        __html: `
                            * { margin: 0; padding: 0; box-sizing: border-box; }
                            html { background-color: #212121; color-scheme: dark; }
                            body { font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }

                            [data-auth-show] { display: none !important; }
                            html[data-auth-state="authed"] [data-auth-show="authed"] { display: inline-flex !important; }
                            html[data-auth-state="anon"] [data-auth-show="anon"] { display: inline-flex !important; }
                            html:not([data-auth-state]) [data-auth-show="anon"] { display: inline-flex !important; }
                        `,
                    }}
                />
                <script
                    dangerouslySetInnerHTML={{
                        __html: `(function(){try{var m=document.cookie.match(/(?:^|;\\s*)flux_user_handle=([^;]+)/);document.documentElement.setAttribute('data-auth-state',m?'authed':'anon');}catch(e){document.documentElement.setAttribute('data-auth-state','anon');}})();`,
                    }}
                />
                {/* Browser RUM beacon (Web Vitals + resource timing) on the
                    public site-token lane — same ingest pipeline and dashboard
                    as the main app, under the `search` environment. The token
                    is a public routing key by design; see rumSiteTokens.ts.
                    This SSR shell serves anonymous visitors and bots; signed-in
                    users get either the R2 SPA fallback shell (which carries
                    its own copy of the snippet) or, on canonical routes, the
                    main app whose RUM already covers them — so no page load
                    ever runs two beacons. */}
                <script
                    dangerouslySetInnerHTML={{
                        __html: buildRumBeaconSnippet(
                            `https://app.flux.ai/telemetry/perf?${RUM_SITE_TOKEN_QUERY_PARAM}=${RUM_SEARCH_SITE_TOKEN}`,
                        ),
                    }}
                />
            </head>
            <body>
                {children}
                <ScrollRestoration />
                <Scripts />
            </body>
        </html>
    );
}

export {HtmlLayout as Layout};

export default function Root() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Layout>
                <Outlet />
            </Layout>
        </ThemeProvider>
    );
}
